/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_Save_PrefixInputs */

const en_onboarding_results_save_prefix = /** @type {(inputs: Onboarding_Results_Save_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can save `)
};

const es_onboarding_results_save_prefix = /** @type {(inputs: Onboarding_Results_Save_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes ahorrar `)
};

/**
* | output |
* | --- |
* | "You can save" |
*
* @param {Onboarding_Results_Save_PrefixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_save_prefix = /** @type {((inputs?: Onboarding_Results_Save_PrefixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_Save_PrefixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_save_prefix(inputs)
	return en_onboarding_results_save_prefix(inputs)
});